import type { FragmentType } from '@packages/gql/generated/shopping';
import type { ProductPriceFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductPriceFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';

export const getUnmaskedPriceData = (data: FragmentType<typeof ProductPriceFragmentFragmentDoc>) =>
  unmask<typeof ProductPriceFragmentFragmentDoc>(data);
